export const version = 'kunde-v1.20.0-SNAPSHOT-69978cb0fd5c7138841609dbbcfdb184d5ce50c8';